module.exports = __webpack_public_path__ + "07_medium_grey.a58a7c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/07_medium_grey.png
// module id = Quw1
// module chunks = 0